import { checkoutReviewAndSubmitActionButtonsStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitActionButtons";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

checkoutReviewAndSubmitActionButtonsStyles.backButton = {
    mergeCss:true,
    variant: "secondary",
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 50%;
                        `,
                        css`
                            flex-shrink: 1;
                        `,
                        css`
                            flex-shrink: 1;
                        `,
                        css`
                            flex-shrink: 1;
                        `,
                        css`
                            flex-shrink: 1;
                        `,
                    ],
                    "max",
                )}
        `,
}

checkoutReviewAndSubmitActionButtonsStyles.placeOrderButton = {
    mergeCss:true,
    css: css`
        flex-shrink: 0;
        margin-left: 10px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: 50%;
                    `,
                ],
                "max",
            )}
    `,
}

checkoutReviewAndSubmitActionButtonsStyles.submitForApprovalButton = {
    mergeCss:true,
    css: css`
        flex-shrink: 0;
        margin-left: 10px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: 50%;
                    `,
                ],
                "max",
            )}
    `,
}